import { Component, ViewChild } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TPVServices } from "../../tpv/services";
import { Globals } from "../../../globals";
import { ConfigurationRoomsCreatePage } from "./configuration-rooms-create/configuration-rooms-create";
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { TranslateService } from '@ngx-translate/core';
import firebase from 'firebase';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateTablePage } from '../../components/popups/create-table/create-table';
import { CompCreateRoomPage } from '../../components/popups/create-room/create-room';


/**
 * Generated class for the ConfigurationRoomsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-rooms',
  templateUrl: 'configuration-rooms.html',
})
export class ConfigurationRoomsPage {

  firestore;
  analytics_occupancy_persons: any;
  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };
  sorts = [{ prop: 'name', dir: 'desc' }, { prop: 'order', dir: 'desc' }]

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public alertCtrl: AlertController) {

    this.firestore = firebase.firestore();
    this.analytics_occupancy_persons = this.globals.restaurant.analytics_occupancy_persons;

    this.globals.GAtrackView('Configuration', 'Configuration - Rooms - List', this.globals.restaurant.email, 'View', 'List rooms', 'Configuration', '');
    this.tpvServices.getRooms(this.globals.restaurant_uid);
    this.tpvServices.getTables(this.globals.restaurant_uid);
    this.tpvServices.getCashs(this.globals.restaurant_uid);
  }

  createRoom() {
    //Si tiene un limite de cajas para crear
    if (this.tpvServices.total_rooms >= this.globals.checkLimitsByLicense('config', 'rooms') && this.globals.checkLimitsByLicense('config', 'rooms') != -1) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      let profileModal = this.modalCtrl.create(CompCreateRoomPage, { room: [], update: false });
      profileModal.present();
    }
  }

  editMap(room) {
    if (room.active) {
      this.navCtrl.push(ConfigurationRoomsCreatePage, {
        update: true,
        room: room
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  editRoom(room) {
    if (room.active) {
      let profileModal = this.modalCtrl.create(CompCreateRoomPage, { room: room, update: true });
      profileModal.present();
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  clickElement(event, index_room) {
    if (event.type == 'click') {
      if (event.column.name == 'duplicate') {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('duplicar-mesa'),
          message: this.translate.instant('duplicar-mesa-seguro'),
          inputs: [
            {
              name: 'name',
              placeholder: this.translate.instant('general-nombre'),
              value: event.row.name
            },
          ],
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => { }
            },
            {
              text: this.translate.instant('general-si'),
              handler: (data) => {
                const newTable = event.row;
                newTable.name = data.name;
                newTable.uid_tickettimeline = '';
                newTable.uid_tickettimeline2 = '';
                newTable.customer = {};
                newTable.discount_type = '';
                newTable.discount_value = 0;
                newTable.state = 'open';
                newTable.notes = '';
                newTable.payment_individual = null;
                newTable.map_left = 0;
                newTable.map_top = 0;
                newTable.map_insert = false;
                newTable.ticket = {
                  amount: 0,
                  date: '',
                  list: {},
                  number: '',
                  payment: false,
                  payment_type: '',
                  waiter: '',
                  waiter_uid: '',
                  updated_at: new Date(),
                  tip: 0
                };
                delete newTable.UID;
                this.tpvServices.afs.collection('tables').add(newTable);
                this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Table - Create', this.globals.restaurant.email, 'Create/Update', 'Create table room', 'Configuration', newTable.name);
              }
            }
          ]
        });
        alert.present();
      } else {
        let profileModal = this.modalCtrl.create(CompCreateTablePage, { table: event.row, room: this.tpvServices.rooms_panels[index_room], update: true });
        profileModal.present();
      }
    }
  }

  onSort(event, index_room) {
    var tables_array = this.tpvServices.rooms_panels[index_room].content;

    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          tables_array.sort((a, b) => a['name'].localeCompare(b['name']));
        } else {
          tables_array.sort((a, b) => b['name'].localeCompare(a['name']));
        }
        break;
      case 'order':
        if (event.newValue == 'asc') {
          tables_array.sort((a, b) => a.order - b.order);
        } else {
          tables_array.sort((a, b) => b.order - a.order);
        }
        break;
    }

    this.tpvServices.rooms_panels[index_room].content = tables_array;
  }

  togglePanel(index: number) {
    if (this.tpvServices.rooms_panels[index].active == false) {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      // Alterna el estado del panel al hacer clic
      this.tpvServices.rooms_panels[index].open = !this.tpvServices.rooms_panels[index].open;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rooms/configuration-rooms.ts